<script setup lang="ts">
import WrChat from '../atoms/icons/WrChat.vue';
import { useRootStore } from "~/stores/root"
import WrLoading from '../atoms/icons/WrLoading.vue';

const rootStore = useRootStore()

const openChat = () => {
  if (!rootStore.drift) {
    rootStore.activateDrift()
  } else {
    rootStore.showDriftChat()
  }
}
</script>

<template>
  <div class="group relative">
    <button
      class="bg-[#5f4ca4] shadow-md max-w-14 max-h-14 size-full rounded-full text-white text-center px-[16px] py-[7px] bg-[linear-gradient(to_right_bottom,_#243ea1,_#283aa2,_#2d36a3,_#3231a3,_#372ca3,_#3f2ba4,_#462aa6,_#4d28a7,_#572baa,_#602eae,_#6932b1,_#7235b4)] mt-5 font-medium w-full fixed z-[999] bottom-3 md:bottom-9 right-3 md:right-9 flex justify-between items-center"
      @click="openChat"
      :disabled="rootStore.isChatLoading"
    >
      <WrChat v-if="!rootStore.isChatLoading" />
      <WrLoading v-else />
    </button>

    <!-- Tooltip -->
    <span
      class="absolute -left-44 bottom-1/2 translate-y-1/2 px-3 py-1 text-sm font-medium text-white bg-gray-900 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-[1000] pointer-events-none shadow-lg"
    >
      Talk to our experts
    </span>
  </div>
</template>
